/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
*
* created by nganesan
* To edit attribute name and long name(desc)
*/

import React from 'react';
import reactCSS from 'reactcss'
import DerivedAttributeComponent from './DerivedAttributeComponent.jsx';
import FormulaHelperComponent from './FormulaHelperComponent.jsx';
import PlainButton from '../common/PlainButton.js';
import ToolTip from '../common/ToolTip.js';

class NameDescEditComponent extends React.Component {
    constructor(props) {
        super(props);
        let attr = this.props.attributeObj,
            evalError = ( attr.isDerived && attr.formula ) ? this.evaluationErrorMessage( attr.formula ) : "";
        this.state = {
          attributeObj: attr,
          attrName: attr.name,
          attrLongName: attr.longName,
          isDerived: attr.isDerived,
          formulaString: attr.isDerived ? attr.formulaString : "",
          evalError: evalError,
          parseError: evalError || "",
          selectedFormula: ""
      };
    }

    updateFormula = (formulaString) => {
        let Dyn = this.props.Dyn;

        this.setState({
            formulaString: formulaString
        });

        var formula = new Dyn.AttributeFormula(formulaString),
            error = '';
        if( formula.isEmptyFormula() ) {
            error = this.emptyExpressionMessage();
        } else if( formula.checkForSyntaxOrReferenceError( Dyn.dataSet )) {
            error = this.syntaxOrReferenceErrorMessage();
        } // not yet evaluated so evaluation error not yet possible
        this.setState( {
            parseError: error
        } );
    }

    emptyExpressionMessage() {
        return this.getLoc( "Please enter valid expression." );
    }

    syntaxOrReferenceErrorMessage() {
        return this.getLoc( 'Syntax error: Please enter valid expression' ) + '.';
    }

    evaluationErrorMessage( formula ) {
        let errorParameters = formula.checkforEvaluationError();
        if( errorParameters ) {
            return this.getLoc( 'Evaluation error for {{errors}} of {{total}} cases.', errorParameters );
        }
        return ''; // no error
    }

    updateHelp = (selectedFormula) => {
        this.setState({
            selectedFormula: selectedFormula
        });
    }

    handleBlur = () => {
        const isNameChanged = this.state.attrName != this.props.attributeObj.name;
        const isLongNameChanged = this.state.attrLongName != this.props.attributeObj.longName;
        let isFormulaChanged = false;
        if(this.props.attributeObj.isDerived) {
            isFormulaChanged = this.state.formulaString != this.props.attributeObj.formulaString;
        }
        if(!!this.props.saveOnBlur && (isNameChanged || isLongNameChanged || isFormulaChanged)) {
            this.handleSave();
        }
    }

    // Callback for input/texarea value changes
    changeHandler = (event) => {
        if(event.target.name === "attrName") {
            this.setState({
                attrName: event.target.value
            });
        } else {
            this.setState({
                attrLongName: event.target.value
            });
        }
    }

    // Callback for close button click
    handleClose = () => {
        this.props.handleClose(false);
    }

    // Callback for save button click
    handleSave = () => {
        let Dyn = this.props.Dyn;
        // if formulastring exists
        // check the length of formula for derived attribute
        if (this.state.isDerived && this.state.formulaString.length==0){
            this.setState({
                parseError: this.emptyExpressionMessage()
            });
            return;
        }
        // If formula is involved, check for the possible syntax error
        if (this.state.formulaString){
            let formula = new Dyn.AttributeFormula( this.state.formulaString );
            if ( formula.isEmptyFormula() || formula.checkForSyntaxOrReferenceError( Dyn.dataSet )){
                this.setState({
                    parseError: this.syntaxOrReferenceErrorMessage()
                });
                return;
            } // not yet evaluated so evaluation error not yet possible
        }

        if(this.state.attrName) {
            this.props.handleClose(true, this.state);
        }
    }

    // To move cursor to the end
    moveCaretAtEnd = (e) => {
        var temp_value = e.target.value;
        e.target.value = '';
        e.target.value = temp_value;
    }

    getLoc = (str, scope) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc( str, scope );
    }

    // To render the DerivedAttributeComponent when the edit button is clicked
    derivedAttributeComponent = () => {
        if ( this.state.isDerived ) {
            // onChange={this.changeHandler}
            return <DerivedAttributeComponent
                Dyn={this.props.Dyn}
                handleBlur={this.handleBlur}
                handleClose={this.handleNameDescEditClose} updateHelp={ this.updateHelp } updateFormula={ this.updateFormula } onChange={ this.changeHandler } formulaString={ this.state.formulaString } attributeObj={ this.state.attributeObj } parseError={this.state.parseError} reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>;
        }
    }

    formulaHelperComponent = () => {
        if (this.state.isDerived ) {
            return <FormulaHelperComponent
                Dyn={this.props.Dyn}
                selectedFormula={ this.state.selectedFormula } reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>;
        }
    }

    render = () => {
        const styles = reactCSS({
            'default': {
                invalidInput: {
                    border: "1px solid #e9322d",
                    boxShadow: "0 0 6px #f8b9b7"
                },
            },
        });

        return (
                <React.Fragment>
                    <div className={"tde-row tde-mt-3" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
                            <div className="tde-label tde-s1 tde-font-weight-bold tde-attr-name tde-mb-2">{ this.getLoc('Name') }<ToolTip tip={this.props.isNew ? this.getLoc('Input name of new attribute'):this.getLoc('Input name of attribute')} Dyn={this.props.Dyn} dir="r"><i role="button" aria-label={this.props.isNew ? this.getLoc('Input name of new attribute'):this.getLoc('Input name of attribute')} className="tde-i tde-i-help tde-ml-1"></i></ToolTip></div>
                            <input type="text" value={this.state.attrName} ref="attrName" name="attrName"
                                aria-label={this.props.isNew ? this.getLoc('Input the name of your new attribute'):this.getLoc('Attribute Name')}
                                className="tde-input tde-input-text"
                                autoFocus = {this.props.autoFocus}
                                required={true}
                                style={(!this.state.attrName ? styles.invalidInput : null)}
                                onChange={this.changeHandler} onFocus={this.moveCaretAtEnd}
                                onBlur={this.handleBlur}/>
                    </div>

                    { this.props.isNew !== true &&
                    <div className={"tde-row tde-divider-bottom tde-pb-4  tde-mt-3" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
                        <div className="tde-label tde-s1 tde-font-weight-bold tde-attr-name tde-mb-2">{ this.getLoc('Description') }</div>
                        <textarea type="text" value={this.state.attrLongName} name="attrLongName"
                                aria-label={this.getLoc('Attribute Description')}
                                className="tde-input tde-input-text"
                                onChange={this.changeHandler} onFocus={this.moveCaretAtEnd} onBlur={this.handleBlur}></textarea>
                    </div>
                    }
                    { this.derivedAttributeComponent() }

                    {!this.props.saveOnBlur && <div className={"tde-footer-btn-group" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
                        <button className="tde-add-button tde-s1 tde-font-weight-bold tde-mt-4 tde-mb-4 tde-px-3 tde-btn tde-mr-0"
                                disabled={!this.state.attrName} onClick={this.handleSave}>
                                { this.getLoc('Save') }</button>
                        <PlainButton className="tde-s1 tde-p-2 tde-pl-3" onClick={this.handleClose}>{ this.getLoc('Cancel') }</PlainButton>
                    </div>}
                    { this.formulaHelperComponent() }
                    {this.props.saveOnBlur && <div className="tde-name-desc-bottom-border"></div>}
                </React.Fragment>
        );
    }
}

export default NameDescEditComponent;
